import { ShipmentRequestModel } from "api/lokiRequestModels/shipments/ShipmentRequestModel";
import { services } from "api/serviceConfig";
import { makeAutoObservable } from "mobx";
import { ShipmentDetails } from "../models/shipmentDetails/ShipmentDetails";

export class ShipmentViewStore {
    shipment: ShipmentDetails | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    get routeName() {
        return this.shipment ? this.shipment.routeName : "";
    }

    get laneName() {
        return this.shipment ? this.shipment.laneName : "";
    }

    loadShipment = async (request: ShipmentRequestModel) => {
        try {
            const response = await services.Shipment.getShipment(request);
            this.shipment = response.data.shipmentDetails;
        } catch (error) {
            console.log(error);
        }
    };
}
